'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var APIBaseResponse = function () {
    function APIBaseResponse($ionicPopup, $ionicLoading, $state, localStorageService) {
        _classCallCheck(this, APIBaseResponse);

        this.$state = $state;
        this.localStorageService = localStorageService;
        this.$ionicPopup = $ionicPopup;
        var self = this;
        return {

            /**
             * Base on success method for api calls
             *
             * @param  {Object} response
             * @return {Object} res
             */
            onSuccess: function onSuccess(response) {
                var res = null;

                if (!angular.isUndefined(response)) {
                    if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object') {
                        res = response.plain();
                    } else {
                        res = response;
                    }
                }

                return res;
            },

            /**
             * Base on success method for blob api calls
             *
             * @param  {Object} response
             * @return {Object} res
             */
            onBlobSuccess: function onBlobSuccess(response) {
                return response;
            },

            /**
             * Base on error method for api calls
             *
             * @param  {Object} error
             * @return {void}
             */
            onError: function onError(error) {

                self.handleError(error);

                // remove any existance of spinner in case of error
                $ionicLoading.hide();
            },

            onLoginError: function onLoginError(error) {
                if (error) {
                    if (error.status === -1 || error.status === 503) {
                        $ionicPopup.alert({
                            title: '<b>Error</b>',
                            template: '<span focus-button>{{"ERR_SERVER_DOWN" | translate }}</span>',
                            okType: 'button-picton-blue'
                        });
                    } else {
                        self.handleError(error);
                    }
                }
                $ionicLoading.hide();
            }
        };
    }

    _createClass(APIBaseResponse, [{
        key: 'handleError',
        value: function handleError(error) {
            if (error && error.data && error.data.message) {
                if (error.data.code === 'ERR_INVALID_TOKEN') {
                    this.$state.go('login');
                    if (!this.localStorageService.get('notAuthorized')) {
                        this.localStorageService.set('notAuthorized', true);
                        this.localStorageService.remove('token');
                        this.$ionicPopup.alert({
                            title: '<b>Error</b>',
                            template: '<span focus-button>{{"' + error.data.code + '" | translate }}</span>',
                            okType: 'button-picton-blue'
                        });
                    }
                } else {
                    this.$ionicPopup.alert({
                        title: '<b>Error</b>',
                        template: '<span focus-button>{{"' + error.data.code + '" | translate }}</span>',
                        okType: 'button-picton-blue'
                    });
                }
            }
        }
    }]);

    return APIBaseResponse;
}();

exports.default = APIBaseResponse;


/** WEBPACK FOOTER **
 ** ./src/app/services/apiBaseResponse.js
 **/